// // // import { FaEnvelope } from "react-icons/fa";
// // // import { FaLocationDot } from "react-icons/fa6";
// // // import { PiDiscordLogo } from "react-icons/pi";
// // // import { SlSocialYoutube } from "react-icons/sl";
// // // import { FaXTwitter } from "react-icons/fa6";
// // // import { LuInstagram } from "react-icons/lu";
// // // import { useRef, useState } from "react";

// // // const BookADemo = () => {
// // //   const nameRef = useRef("");
// // //   const lastNameRef = useRef("");
// // //   const emailRef = useRef("");
// // //   const phoneRef = useRef("");
// // //   const message = useRef("");
// // //   const [isError, setIsError] = useState(false);
// // //   const [isLoading, setIsLoading] = useState(false);
// // //   const [formStatus, setFormStatus] = useState("");

// // //   const validateForm = () => {
// // //     if (
// // //       nameRef.current.value === "" ||
// // //       emailRef.current.value === "" ||
// // //       phoneRef.current.value === "" ||
// // //       message.current.value === ""
// // //     ) {
// // //       return false;
// // //     }
// // //     return true;
// // //   };

// // //   const handleSubmit = async () => {
// // //     setIsLoading(true);
// // //     if (validateForm()) {
// // //       const body = {
// // //         name: nameRef.current.value,
// // //         email: emailRef.current.value,
// // //         phoneNumber: phoneRef.current.value,
// // //         message: message.current.value,
// // //         ...(lastNameRef.current.value && { lastName: lastNameRef.current.value }),
// // //       };
// // //       try {
// // //         const resp = await fetch(
// // //           "https://juridentfeedbackmailbackend.onrender.com/send-demoRequest",
// // //           {
// // //             method: "POST",
// // //             body: JSON.stringify(body),
// // //             headers: { "Content-Type": "application/json" },
// // //           }
// // //         );

// // //         const respJson = await resp.text();
// // //         console.log(respJson);

// // //         // Reset inputs
// // //         [nameRef, lastNameRef, emailRef, phoneRef, message].forEach(ref => (ref.current.value = ""));
// // //         setFormStatus("success");
// // //       } catch (error) {
// // //         console.log(error);
// // //         setFormStatus("error");
// // //       }
// // //     } else {
// // //       setIsError(true);
// // //       nameRef.current.value = "Required";
// // //       emailRef.current.value = "Required";
// // //       phoneRef.current.value = "Required";
// // //       message.current.value = "Required";
// // //       setFormStatus("error");

// // //       setTimeout(() => {
// // //         setIsError(false);
// // //         setFormStatus("");
// // //         [nameRef, lastNameRef, emailRef, phoneRef, message].forEach(ref => (ref.current.value = ""));
// // //       }, 3000);
// // //     }

// // //     setTimeout(() => {
// // //       setIsError(false);
// // //       setFormStatus("");
// // //       [nameRef, lastNameRef, emailRef, phoneRef, message].forEach(ref => (ref.current.value = ""));
// // //     }, 3000);

// // //     setIsLoading(false);
// // //   };

// // //   return (
// // //     <div className="w-full min-h-screen flex justify-center items-center px-4 sm:px-12 overflow-auto">
// // //       <div className="w-full max-w-[95%] sm:max-w-[1100px] h-fit sm:h-[60%] mt-[100px] shadow-[0_0_15px_rgba(0,0,0,0.25)] rounded-[20px] flex flex-col sm:flex-row px-4 sm:px-16 py-4 sm:py-12 text-[0.8rem] sm:text-[0.9rem]">
// // //         {/* LEFT PANEL */}
// // //         <div className="w-full sm:w-[45%] flex flex-col items-start justify-between pr-0 sm:pr-[40px] sm:border-r border-gray-300 mb-6 sm:mb-0">
// // //           <div className="w-full flex flex-col items-start">
// // //             <h1 className="font-bold text-[0.9rem] sm:text-[1rem] md:text-[1.1rem] lg:text-[1.2rem] mb-2 sm:mb-6 text-[#D0A95C]">
// // //               Drop in your details and we will reach out to you shortly
// // //             </h1>
// // //             <div className="w-full text-[#1e1e1e] hidden sm:flex flex-col space-y-2">
// // //               <div className="flex items-center text-[0.8rem]">
// // //                 <FaEnvelope />
// // //                 <span className="ml-2 font-semibold">connect@valscotech.com</span>
// // //               </div>
// // //               <div className="flex items-start text-[0.8rem]">
// // //                 <FaLocationDot className="mt-[2px]" />
// // //                 <span className="ml-2 leading-relaxed">
// // //                   Valsco Technology,
// // //                   <br /> J-3 Shatabdi Enclave
// // //                   <br /> Noida-201301, Uttar Pradesh
// // //                 </span>
// // //               </div>
// // //             </div>
// // //           </div>
// // //           <div className="hidden sm:flex items-center ml-[5px] mt-4 text-gray-500 font-light space-x-3 text-[0.85rem]">
// // //             <PiDiscordLogo className="hover:text-[#D0A95C]" />
// // //             <SlSocialYoutube className="hover:text-[#D0A95C]" />
// // //             <FaXTwitter className="hover:text-[#D0A95C]" />
// // //             <LuInstagram className="hover:text-[#D0A95C]" />
// // //           </div>
// // //         </div>

// // //         {/* FORM PANEL */}
// // //         <div className="flex flex-col items-center w-full sm:w-[55%] pb-[15px]">
// // //           <div className="flex flex-col items-center w-full sm:w-[90%] space-y-8 sm:space-y-10">
// // //             {/* Form Fields */}
// // //             <div className="flex flex-col font-semibold w-full space-y-6 sm:space-y-8">
// // //               {/* Row 1 */}
// // //               <div className="flex flex-col sm:flex-row sm:justify-between sm:space-x-6 space-y-4 sm:space-y-0">
// // //                 <div className="flex flex-col w-full sm:w-[50%] space-y-1">
// // //                   <p className="text-[#D0A95C] text-[0.85rem]">First Name*</p>
// // //                   <input
// // //                     type="text"
// // //                     className={`outline-none border-b ${
// // //                       isError ? "border-red-500 text-red-500 font-light text-[0.75rem]" : "border-black"
// // //                     }`}
// // //                     ref={nameRef}
// // //                   />
// // //                 </div>
// // //                 <div className="flex flex-col w-full sm:w-[50%] space-y-1">
// // //                   <p className="text-[#D0A95C] text-[0.85rem]">Last Name</p>
// // //                   <input type="text" className="outline-none border-b border-black text-[0.8rem]" ref={lastNameRef} />
// // //                 </div>
// // //               </div>

// // //               {/* Row 2 */}
// // //               <div className="flex flex-col sm:flex-row sm:justify-between sm:space-x-6 space-y-4 sm:space-y-0">
// // //                 <div className="flex flex-col w-full sm:w-[50%] space-y-1">
// // //                   <p className="text-[#D0A95C] text-[0.85rem]">Email*</p>
// // //                   <input
// // //                     type="text"
// // //                     className={`outline-none border-b ${
// // //                       isError ? "border-red-500 text-red-500 font-light text-[0.75rem]" : "border-black"
// // //                     }`}
// // //                     ref={emailRef}
// // //                   />
// // //                 </div>
// // //                 <div className="flex flex-col w-full sm:w-[50%] space-y-1">
// // //                   <p className="text-[#D0A95C] text-[0.85rem]">Phone*</p>
// // //                   <input
// // //                     type="text"
// // //                     className={`outline-none border-b ${
// // //                       isError ? "border-red-500 text-red-500 font-light text-[0.75rem]" : "border-black"
// // //                     }`}
// // //                     ref={phoneRef}
// // //                   />
// // //                 </div>
// // //               </div>
// // //             </div>

// // //             {/* Message */}
// // //             <div className="flex flex-col w-full relative space-y-1">
// // //               <p
// // //                 className={`transition-all duration-500 font-semibold text-[#D0A95C] text-[0.85rem] transform ${
// // //                   formStatus ? "translate-y-[40px] opacity-0" : "translate-y-0 opacity-100"
// // //                 }`}
// // //               >
// // //                 Message*
// // //               </p>
// // //               <p
// // //                 className={`absolute text-green-600 font-bold text-[0.75rem] transition-all duration-500 ${
// // //                   formStatus === "success" ? "translate-y-0 opacity-100" : "-translate-y-[30px] opacity-0"
// // //                 }`}
// // //               >
// // //                 Request sent successfully
// // //               </p>
// // //               <p
// // //                 className={`absolute text-red-500 font-bold text-[0.75rem] transition-all duration-500 ${
// // //                   formStatus === "error" ? "translate-y-0 opacity-100" : "-translate-y-[30px] opacity-0"
// // //                 }`}
// // //               >
// // //                 Error sending request
// // //               </p>
// // //               <input
// // //                 type="text"
// // //                 className={`outline-none border-b ${
// // //                   isError ? "border-red-500 text-red-500 font-light text-[0.75rem]" : "border-black"
// // //                 } font-normal text-[0.8rem]`}
// // //                 placeholder="Write your Message"
// // //                 ref={message}
// // //               />
// // //             </div>

// // //             {/* Submit Button */}
// // //             <div className="flex w-full">
// // //               <button
// // //                 onClick={handleSubmit}
// // //                 disabled={isLoading}
// // //                 className="relative w-full px-4 py-2 rounded-xl text-[0.85rem] font-semibold text-white bg-[#D0A95C]/90 backdrop-blur-md bg-opacity-30 shadow-md hover:shadow-[0_0_15px_rgba(208,169,92,0.4)] transition-all duration-300 ease-in-out hover:scale-105 overflow-hidden disabled:opacity-60 disabled:cursor-not-allowed"
// // //               >
// // //                 {isLoading ? (
// // //                   <span className="flex items-center justify-center">
// // //                     <svg className="animate-spin h-3 w-3 text-white mr-2" viewBox="0 0 24 24">
// // //                       <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
// // //                       <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
// // //                     </svg>
// // //                     Sending...
// // //                   </span>
// // //                 ) : (
// // //                   "Book Demo"
// // //                 )}
// // //               </button>
// // //             </div>
// // //           </div>
// // //         </div>
// // //       </div>
// // //     </div>
// // //   );
// // // };

// // // export default BookADemo;
















// // import { FaEnvelope } from "react-icons/fa";
// // import { FaLocationDot } from "react-icons/fa6";
// // import { PiDiscordLogo } from "react-icons/pi";
// // import { SlSocialYoutube } from "react-icons/sl";
// // import { FaXTwitter } from "react-icons/fa6";
// // import { LuInstagram } from "react-icons/lu";
// // import { useRef, useState } from "react";

// // const BookADemo = () => {
// //   const nameRef = useRef("");
// //   const lastNameRef = useRef("");
// //   const emailRef = useRef("");
// //   const phoneRef = useRef("");
// //   const message = useRef("");

// //   const [isError, setIsError] = useState(false);
// //   const [isLoading, setIsLoading] = useState(false);
// //   const [formStatus, setFormStatus] = useState("");

// //   const validateForm = () => {
// //     return !(
// //       nameRef.current.value === "" ||
// //       emailRef.current.value === "" ||
// //       phoneRef.current.value === "" ||
// //       message.current.value === ""
// //     );
// //   };

// //   const handleSubmit = async () => {
// //     setIsLoading(true);

// //     if (validateForm()) {
// //       const body = {
// //         name: nameRef.current.value,
// //         email: emailRef.current.value,
// //         phoneNumber: phoneRef.current.value,
// //         message: message.current.value,
// //         ...(lastNameRef.current.value && { lastName: lastNameRef.current.value }),
// //       };

// //       try {
// //         await fetch(
// //           "https://juridentfeedbackmailbackend.onrender.com/send-demoRequest",
// //           {
// //             method: "POST",
// //             body: JSON.stringify(body),
// //             headers: { "Content-Type": "application/json" },
// //           }
// //         );

// //         [nameRef, lastNameRef, emailRef, phoneRef, message].forEach(
// //           ref => (ref.current.value = "")
// //         );
// //         setFormStatus("success");
// //       } catch {
// //         setFormStatus("error");
// //       }
// //     } else {
// //       setIsError(true);
// //       setFormStatus("error");
// //       [nameRef, emailRef, phoneRef, message].forEach(ref => {
// //         ref.current.value = "Required";
// //       });
// //     }

// //     setTimeout(() => {
// //       setIsError(false);
// //       setFormStatus("");
// //       [nameRef, lastNameRef, emailRef, phoneRef, message].forEach(
// //         ref => (ref.current.value = "")
// //       );
// //     }, 3000);

// //     setIsLoading(false);
// //   };

// //   return (
// //     <section className="min-h-screen flex items-center justify-center px-4 py-24 bg-[#fafafa]">

// //       <div className="max-w-6xl w-full grid grid-cols-1 md:grid-cols-2 rounded-3xl
// //         bg-white/70 backdrop-blur-xl
// //         shadow-[0_30px_80px_rgba(0,0,0,0.12)]
// //         border border-[#D0A95C]/20 overflow-hidden">

// //         {/* LEFT PANEL */}
// //         <div className="p-10 flex flex-col justify-between bg-gradient-to-br from-[#111] to-[#1b1b1b] text-white">

// //           <div>
// //             <h1 className="text-2xl md:text-3xl font-extrabold text-[#D0A95C] mb-6">
// //               Book a Demo
// //             </h1>

// //             <p className="text-sm leading-relaxed text-gray-300 max-w-sm">
// //               Drop in your details and our team will connect with you shortly to
// //               walk you through Jurident’s capabilities.
// //             </p>

// //             <div className="mt-10 space-y-4 text-sm">
// //               <div className="flex items-center gap-3">
// //                 <FaEnvelope />
// //                 <span>connect@valscotech.com</span>
// //               </div>

// //               <div className="flex items-start gap-3">
// //                 <FaLocationDot className="mt-1" />
// //                 <span>
// //                   Valsco Technology <br />
// //                   J-3 Shatabdi Enclave <br />
// //                   Noida-201301, UP
// //                 </span>
// //               </div>
// //             </div>
// //           </div>

// //           <div className="flex gap-4 text-xl text-gray-400 mt-10">
// //             <PiDiscordLogo className="hover:text-[#D0A95C]" />
// //             <SlSocialYoutube className="hover:text-[#D0A95C]" />
// //             <FaXTwitter className="hover:text-[#D0A95C]" />
// //             <LuInstagram className="hover:text-[#D0A95C]" />
// //           </div>
// //         </div>

// //         {/* FORM PANEL */}
// //         <div className="p-10 flex flex-col justify-center">
// //           <div className="space-y-8">

// //             {/* Inputs */}
// //             <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
// //               <Input label="First Name*" refProp={nameRef} isError={isError} />
// //               <Input label="Last Name" refProp={lastNameRef} />
// //               <Input label="Email*" refProp={emailRef} isError={isError} />
// //               <Input label="Phone*" refProp={phoneRef} isError={isError} />
// //             </div>

// //             {/* Message */}
// //             <div>
// //               <p className="text-[#D0A95C] font-semibold text-sm mb-1">
// //                 Message*
// //               </p>

// //               <p className={`text-sm font-semibold transition-all ${
// //                 formStatus === "success"
// //                   ? "text-green-600"
// //                   : formStatus === "error"
// //                   ? "text-red-500"
// //                   : "hidden"
// //               }`}>
// //                 {formStatus === "success"
// //                   ? "Request sent successfully"
// //                   : "Error sending request"}
// //               </p>

// //               <input
// //                 ref={message}
// //                 placeholder="Write your message"
// //                 className={`w-full mt-2 border-b bg-transparent outline-none py-2 text-sm
// //                 ${isError ? "border-red-500 text-red-500" : "border-black"}`}
// //               />
// //             </div>

// //             {/* Submit */}
// //             <button
// //               onClick={handleSubmit}
// //               disabled={isLoading}
// //               className="w-full py-3 rounded-xl font-semibold text-white
// //               bg-gradient-to-r from-[#D0A95C] to-[#bfa06a]
// //               shadow-[0_15px_40px_rgba(208,169,92,0.4)]
// //               hover:scale-[1.03] transition-all disabled:opacity-60"
// //             >
// //               {isLoading ? "Sending..." : "Book Demo"}
// //             </button>
// //           </div>
// //         </div>
// //       </div>
// //     </section>
// //   );
// // };

// // /* Reusable Input */
// // const Input = ({ label, refProp, isError }) => (
// //   <div>
// //     <p className="text-[#D0A95C] font-semibold text-sm mb-1">{label}</p>
// //     <input
// //       ref={refProp}
// //       className={`w-full border-b bg-transparent outline-none py-2 text-sm
// //       ${isError ? "border-red-500 text-red-500" : "border-black"}`}
// //     />
// //   </div>
// // );

// // export default BookADemo;





















// // import { FaEnvelope } from "react-icons/fa";
// // import { FaLocationDot } from "react-icons/fa6";
// // import { PiDiscordLogo } from "react-icons/pi";
// // import { SlSocialYoutube } from "react-icons/sl";
// // import { FaXTwitter } from "react-icons/fa6";
// // import { LuInstagram } from "react-icons/lu";
// // import { useRef, useState } from "react";

// // const BookADemo = () => {
// //   const nameRef = useRef("");
// //   const lastNameRef = useRef("");
// //   const emailRef = useRef("");
// //   const phoneRef = useRef("");
// //   const message = useRef("");

// //   const [isError, setIsError] = useState(false);
// //   const [isLoading, setIsLoading] = useState(false);
// //   const [formStatus, setFormStatus] = useState("");

// //   const validateForm = () => {
// //     return !(
// //       nameRef.current.value === "" ||
// //       emailRef.current.value === "" ||
// //       phoneRef.current.value === "" ||
// //       message.current.value === ""
// //     );
// //   };

// //   const handleSubmit = async () => {
// //     setIsLoading(true);

// //     if (validateForm()) {
// //       const body = {
// //         name: nameRef.current.value,
// //         email: emailRef.current.value,
// //         phoneNumber: phoneRef.current.value,
// //         message: message.current.value,
// //         ...(lastNameRef.current.value && { lastName: lastNameRef.current.value }),
// //       };

// //       try {
// //         await fetch(
// //           "https://juridentfeedbackmailbackend.onrender.com/send-demoRequest",
// //           {
// //             method: "POST",
// //             body: JSON.stringify(body),
// //             headers: { "Content-Type": "application/json" },
// //           }
// //         );

// //         [nameRef, lastNameRef, emailRef, phoneRef, message].forEach(
// //           ref => (ref.current.value = "")
// //         );
// //         setFormStatus("success");
// //       } catch {
// //         setFormStatus("error");
// //       }
// //     } else {
// //       setIsError(true);
// //       setFormStatus("error");
// //       [nameRef, emailRef, phoneRef, message].forEach(ref => {
// //         ref.current.value = "Required";
// //       });
// //     }

// //     setTimeout(() => {
// //       setIsError(false);
// //       setFormStatus("");
// //       [nameRef, lastNameRef, emailRef, phoneRef, message].forEach(
// //         ref => (ref.current.value = "")
// //       );
// //     }, 3000);

// //     setIsLoading(false);
// //   };

// //   return (
// //     <section className="min-h-screen flex items-center justify-center px-4 py-24 bg-[#fafafa]">
// //       <div className="max-w-6xl w-full grid grid-cols-1 md:grid-cols-2 rounded-3xl
// //         bg-white/70 backdrop-blur-xl
// //         shadow-[0_30px_80px_rgba(0,0,0,0.12)]
// //         border border-[#D0A95C]/20 overflow-hidden">

// //         {/* LEFT PANEL */}
// //         <div className="p-10 flex flex-col justify-between bg-gradient-to-br from-[#111] to-[#1b1b1b] text-white">
// //           <div>
// //             <h1 className="text-2xl md:text-3xl font-extrabold text-[#D0A95C] mb-6">
// //               Book Demo
// //             </h1>

// //             <p className="text-sm leading-relaxed text-gray-300 max-w-sm">
// //               Drop in your details and our team will connect with you shortly to
// //               walk you through Jurident’s capabilities.
// //             </p>

// //             <div className="mt-10 space-y-4 text-sm">
// //               <div className="flex items-center gap-3">
// //                 <FaEnvelope />
// //                 <span>connect@valscotech.com</span>
// //               </div>

// //               <div className="flex items-start gap-3">
// //                 <FaLocationDot className="mt-1" />
// //                 <span>
// //                   Valsco Technology <br />
// //                   J-3 Shatabdi Enclave <br />
// //                   Noida-201301, UP
// //                 </span>
// //               </div>
// //             </div>
// //           </div>

// //           {/* ✅ CLICKABLE SOCIAL ICONS */}
// //           <div className="flex gap-4 text-xl text-gray-400 mt-10">
// //             <a
// //               href="https://discord.com"
// //               target="_blank"
// //               rel="noopener noreferrer"
// //               className="hover:text-[#D0A95C] transition hover:scale-110"
// //             >
// //               <PiDiscordLogo />
// //             </a>

// //             <a
// //               href="https://www.youtube.com"
// //               target="_blank"
// //               rel="noopener noreferrer"
// //               className="hover:text-[#D0A95C] transition hover:scale-110"
// //             >
// //               <SlSocialYoutube />
// //             </a>

// //             <a
// //               href="https://twitter.com"
// //               target="_blank"
// //               rel="noopener noreferrer"
// //               className="hover:text-[#D0A95C] transition hover:scale-110"
// //             >
// //               <FaXTwitter />
// //             </a>

// //             <a
// //               href="https://www.instagram.com"
// //               target="_blank"
// //               rel="noopener noreferrer"
// //               className="hover:text-[#D0A95C] transition hover:scale-110"
// //             >
// //               <LuInstagram />
// //             </a>
// //           </div>
// //         </div>

// //         {/* FORM PANEL */}
// //         <div className="p-10 flex flex-col justify-center">
// //           <div className="space-y-8">

// //             <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
// //               <Input label="First Name*" refProp={nameRef} isError={isError} />
// //               <Input label="Last Name" refProp={lastNameRef} />
// //               <Input label="Email*" refProp={emailRef} isError={isError} />
// //               <Input label="Phone*" refProp={phoneRef} isError={isError} />
// //             </div>

// //             <div>
// //               <p className="text-[#D0A95C] font-semibold text-sm mb-1">
// //                 Message*
// //               </p>

// //               <p className={`text-sm font-semibold transition-all ${
// //                 formStatus === "success"
// //                   ? "text-green-600"
// //                   : formStatus === "error"
// //                   ? "text-red-500"
// //                   : "hidden"
// //               }`}>
// //                 {formStatus === "success"
// //                   ? "Request sent successfully"
// //                   : "Error sending request"}
// //               </p>

// //               <input
// //                 ref={message}
// //                 placeholder="Write your message"
// //                 className={`w-full mt-2 border-b bg-transparent outline-none py-2 text-sm
// //                 ${isError ? "border-red-500 text-red-500" : "border-black"}`}
// //               />
// //             </div>

// //             <button
// //               onClick={handleSubmit}
// //               disabled={isLoading}
// //               className="w-full py-3 rounded-xl font-semibold text-white
// //               bg-gradient-to-r from-[#D0A95C] to-[#bfa06a]
// //               shadow-[0_15px_40px_rgba(208,169,92,0.4)]
// //               hover:scale-[1.03] transition-all disabled:opacity-60"
// //             >
// //               {isLoading ? "Sending..." : "Book Demo"}
// //             </button>
// //           </div>
// //         </div>
// //       </div>
// //     </section>
// //   );
// // };

// // /* Reusable Input */
// // const Input = ({ label, refProp, isError }) => (
// //   <div>
// //     <p className="text-[#D0A95C] font-semibold text-sm mb-1">{label}</p>
// //     <input
// //       ref={refProp}
// //       className={`w-full border-b bg-transparent outline-none py-2 text-sm
// //       ${isError ? "border-red-500 text-red-500" : "border-black"}`}
// //     />
// //   </div>
// // );

// // export default BookADemo;













// "use client";

// import { FaEnvelope } from "react-icons/fa";
// import { FaLocationDot } from "react-icons/fa6";
// import { PiDiscordLogo } from "react-icons/pi";
// import { SlSocialYoutube } from "react-icons/sl";
// import { FaXTwitter } from "react-icons/fa6";
// import { LuInstagram } from "react-icons/lu";
// import { useRef, useState } from "react";

// const BookADemo = () => {

//   const nameRef = useRef("");
//   const lastNameRef = useRef("");
//   const emailRef = useRef("");
//   const phoneRef = useRef("");
//   const message = useRef("");

//   const [isError, setIsError] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   const [formStatus, setFormStatus] = useState("");

//   // ✅ NEW STATE
//   const [userType, setUserType] = useState("Advocate");

//   const validateForm = () => {
//     return !(
//       nameRef.current.value === "" ||
//       emailRef.current.value === "" ||
//       phoneRef.current.value === "" ||
//       message.current.value === ""
//     );
//   };

//   const handleSubmit = async () => {
//     setIsLoading(true);

//     if (validateForm()) {
//       const body = {
//         name: nameRef.current.value,
//         email: emailRef.current.value,
//         phoneNumber: phoneRef.current.value,
//         message: message.current.value,
//         userType: userType, // ✅ ADDED
//         ...(lastNameRef.current.value && { lastName: lastNameRef.current.value }),
//       };

//       try {
//         await fetch(
//           "https://juridentfeedbackmailbackend.onrender.com/send-demoRequest",
//           {
//             method: "POST",
//             body: JSON.stringify(body),
//             headers: { "Content-Type": "application/json" },
//           }
//         );

//         [nameRef, lastNameRef, emailRef, phoneRef, message].forEach(
//           ref => (ref.current.value = "")
//         );
//         setFormStatus("success");
//       } catch {
//         setFormStatus("error");
//       }
//     } else {
//       setIsError(true);
//       setFormStatus("error");

//       [nameRef, emailRef, phoneRef, message].forEach(ref => {
//         ref.current.value = "Required";
//       });
//     }

//     setTimeout(() => {
//       setIsError(false);
//       setFormStatus("");
//       [nameRef, lastNameRef, emailRef, phoneRef, message].forEach(
//         ref => (ref.current.value = "")
//       );
//     }, 3000);

//     setIsLoading(false);
//   };

//   return (
//    <section className="min-h-screen flex items-center justify-center px-4 pt-32 pb-24 bg-[#fafafa]">

//       <div className="max-w-6xl w-full grid grid-cols-1 md:grid-cols-2 rounded-3xl
//         bg-white/70 backdrop-blur-xl
//         shadow-[0_30px_80px_rgba(0,0,0,0.12)]
//         border border-[#D0A95C]/20 overflow-hidden">

//         {/* LEFT PANEL */}
//         <div className="p-10 flex flex-col justify-between bg-gradient-to-br from-[#111] to-[#1b1b1b] text-white">
          
//           <div>
//             <h1 className="text-2xl md:text-3xl font-extrabold text-[#D0A95C] mb-6">
//               Book Demo
//             </h1>

//             <p className="text-sm leading-relaxed text-gray-300 max-w-sm">
//               Drop in your details and our team will connect with you shortly to
//               walk you through Jurident’s capabilities.
//             </p>

//             <div className="mt-10 space-y-4 text-sm">
//               <div className="flex items-center gap-3">
//                 <FaEnvelope />
//                 <span>connect@valscotech.com</span>
//               </div>

//               <div className="flex items-start gap-3">
//                 <FaLocationDot className="mt-1" />
//                 <span>
//                   Valsco Technology <br />
//                   J-3 Shatabdi Enclave <br />
//                   Noida-201301, UP
//                 </span>
//               </div>
//             </div>
//           </div>

//           {/* SOCIAL */}
//           <div className="flex gap-4 text-xl text-gray-400 mt-10">
//             <a href="https://discord.com" target="_blank" className="hover:text-[#D0A95C] hover:scale-110 transition">
//               <PiDiscordLogo />
//             </a>

//             <a href="https://www.youtube.com" target="_blank" className="hover:text-[#D0A95C] hover:scale-110 transition">
//               <SlSocialYoutube />
//             </a>

//             <a href="https://twitter.com" target="_blank" className="hover:text-[#D0A95C] hover:scale-110 transition">
//               <FaXTwitter />
//             </a>

//             <a href="https://www.instagram.com" target="_blank" className="hover:text-[#D0A95C] hover:scale-110 transition">
//               <LuInstagram />
//             </a>
//           </div>
//         </div>

//         {/* RIGHT PANEL (FORM) */}
//         <div className="p-10 flex flex-col justify-center">

//           {/* 🔥 USER TYPE SELECTOR */}
//           <div className="mb-8">
//             <p className="text-[#D0A95C] font-semibold text-sm mb-3">
//               Select User Type
//             </p>

//             <div className="flex gap-3">
//               <button
//                 onClick={() => setUserType("Advocate")}
//                 className={`px-6 py-2 rounded-full border text-sm font-medium transition
//                   ${userType === "Advocate"
//                     ? "bg-[#D0A95C] text-white border-[#D0A95C] shadow-md"
//                     : "border-gray-300 text-gray-600 hover:border-[#D0A95C]"
//                   }`}
//               >
//                 Advocate
//               </button>

//               <button
//                 onClick={() => setUserType("Enterprise")}
//                 className={`px-6 py-2 rounded-full border text-sm font-medium transition
//                   ${userType === "Enterprise"
//                     ? "bg-[#D0A95C] text-white border-[#D0A95C] shadow-md"
//                     : "border-gray-300 text-gray-600 hover:border-[#D0A95C]"
//                   }`}
//               >
//                 Enterprise
//               </button>
//             </div>
//           </div>

//           {/* FORM */}
//           <div className="space-y-8">

//             <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//               <Input label="First Name*" refProp={nameRef} isError={isError} />
//               <Input label="Last Name" refProp={lastNameRef} />
//               <Input label="Email*" refProp={emailRef} isError={isError} />
//               <Input label="Phone*" refProp={phoneRef} isError={isError} />
//             </div>

//             <div>
//               <p className="text-[#D0A95C] font-semibold text-sm mb-1">
//                 Message*
//               </p>

//               <p className={`text-sm font-semibold ${
//                 formStatus === "success"
//                   ? "text-green-600"
//                   : formStatus === "error"
//                   ? "text-red-500"
//                   : "hidden"
//               }`}>
//                 {formStatus === "success"
//                   ? "Request sent successfully"
//                   : "Error sending request"}
//               </p>

//               <input
//                 ref={message}
//                 placeholder="Write your message"
//                 className={`w-full mt-2 border-b bg-transparent outline-none py-2 text-sm
//                 ${isError ? "border-red-500 text-red-500" : "border-black"}`}
//               />
//             </div>

//             <button
//               onClick={handleSubmit}
//               disabled={isLoading}
//               className="w-full py-3 rounded-xl font-semibold text-white
//               bg-gradient-to-r from-[#D0A95C] to-[#bfa06a]
//               shadow-[0_15px_40px_rgba(208,169,92,0.4)]
//               hover:scale-[1.03] transition-all disabled:opacity-60"
//             >
//               {isLoading ? "Sending..." : "Book Demo"}
//             </button>

//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// /* INPUT COMPONENT */
// const Input = ({ label, refProp, isError }) => (
//   <div>
//     <p className="text-[#D0A95C] font-semibold text-sm mb-1">{label}</p>
//     <input
//       ref={refProp}
//       className={`w-full border-b bg-transparent outline-none py-2 text-sm
//       ${isError ? "border-red-500 text-red-500" : "border-black"}`}
//     />
//   </div>
// );

// export default BookADemo;






























"use client";

import { FaEnvelope } from "react-icons/fa";
import { FaLocationDot } from "react-icons/fa6";
import { PiDiscordLogo } from "react-icons/pi";
import { SlSocialYoutube } from "react-icons/sl";
import { FaXTwitter } from "react-icons/fa6";
import { LuInstagram } from "react-icons/lu";
import { useState, useRef } from "react";
import toast from "react-hot-toast";

const BookADemo = () => {
  const [formStatus, setFormStatus] = useState("");

  const nameRef = useRef("");
  const lastNameRef = useRef("");
  const emailRef = useRef("");
  const phoneRef = useRef("");
  const message = useRef("");

  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [userType, setUserType] = useState("Advocate");

  const validateForm = () => {
    return !(
      nameRef.current.value === "" ||
      emailRef.current.value === "" ||
      phoneRef.current.value === "" ||
      message.current.value === ""
    );
  };

  const handleSubmit = async () => {

    if (!validateForm()) {
      setIsError(true);
      setFormStatus("error");
      return;
    }

    setIsLoading(true);

    const body = {
      name: nameRef.current.value,
      email: emailRef.current.value,
      phoneNumber: phoneRef.current.value,
      message: message.current.value,
      userType: userType,
      ...(lastNameRef.current.value && { lastName: lastNameRef.current.value }),
    };

    try {
      const resp = await fetch(
        "https://jurident-feedback-backend-596718606544.us-central1.run.app/send-demoRequest", // ✅ FIXED
        {
          method: "POST",
          body: JSON.stringify(body),
          headers: { "Content-Type": "application/json" },
        }
      );

      if (!resp.ok) {
        throw new Error("Failed to send request");
      }

      await resp.text();

      [nameRef, lastNameRef, emailRef, phoneRef, message].forEach(
        ref => (ref.current.value = "")
      );

      setFormStatus("success");

    } catch (error) {
      console.error("ERROR:", error); // ✅ DEBUG
      setFormStatus("error");
    }

    setTimeout(() => {
      setIsError(false);
      setFormStatus("");
      [nameRef, lastNameRef, emailRef, phoneRef, message].forEach(
        ref => (ref.current.value = "")
      );
    }, 3000);

    setIsLoading(false);
  };

  return (
   <section className="min-h-screen flex items-center justify-center px-4 pt-32 pb-24 bg-[#fafafa]">

      <div className="max-w-6xl w-full grid grid-cols-1 md:grid-cols-2 rounded-3xl
        bg-white/70 backdrop-blur-xl
        shadow-[0_30px_80px_rgba(0,0,0,0.12)]
        border border-[#D0A95C]/20 overflow-hidden">

        {/* LEFT PANEL */}
        <div className="p-10 flex flex-col justify-between bg-gradient-to-br from-[#111] to-[#1b1b1b] text-white">
          
          <div>
            <h1 className="text-2xl md:text-3xl font-extrabold text-[#D0A95C] mb-6">
              Book Demo
            </h1>

            <p className="text-sm leading-relaxed text-gray-300 max-w-sm">
              Drop in your details and our team will connect with you shortly to
              walk you through Jurident’s capabilities.
            </p>

            <div className="mt-10 space-y-4 text-sm">
              <div className="flex items-center gap-3">
                <FaEnvelope />
                <span>connect@valscotech.com</span>
              </div>

              <div className="flex items-start gap-3">
                <FaLocationDot className="mt-1" />
                <span>
                  Valsco Technology <br />
                  J-3 Shatabdi Enclave <br />
                  Noida-201301, UP
                </span>
              </div>
            </div>
          </div>

          <div className="flex gap-4 text-xl text-gray-400 mt-10">
            <a href="https://discord.com" target="_blank" className="hover:text-[#D0A95C] hover:scale-110 transition">
              <PiDiscordLogo />
            </a>

            <a href="https://www.youtube.com" target="_blank" className="hover:text-[#D0A95C] hover:scale-110 transition">
              <SlSocialYoutube />
            </a>

            <a href="https://twitter.com" target="_blank" className="hover:text-[#D0A95C] hover:scale-110 transition">
              <FaXTwitter />
            </a>

            <a href="https://www.instagram.com" target="_blank" className="hover:text-[#D0A95C] hover:scale-110 transition">
              <LuInstagram />
            </a>
          </div>
        </div>

        {/* RIGHT PANEL */}
        <div className="p-10 flex flex-col justify-center">

          <div className="mb-8">
            <p className="text-[#D0A95C] font-semibold text-sm mb-3">
              Select User Type
            </p>

            <div className="flex gap-3">
              <button
                onClick={() => setUserType("Advocate")}
                className={`px-6 py-2 rounded-full border text-sm font-medium transition
                  ${userType === "Advocate"
                    ? "bg-[#D0A95C] text-white border-[#D0A95C] shadow-md"
                    : "border-gray-300 text-gray-600 hover:border-[#D0A95C]"
                  }`}
              >
                Advocate
              </button>

              <button
                onClick={() => setUserType("Enterprise")}
                className={`px-6 py-2 rounded-full border text-sm font-medium transition
                  ${userType === "Enterprise"
                    ? "bg-[#D0A95C] text-white border-[#D0A95C] shadow-md"
                    : "border-gray-300 text-gray-600 hover:border-[#D0A95C]"
                  }`}
              >
                Enterprise
              </button>
            </div>
          </div>

          <div className="space-y-8">

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <Input label="First Name*" refProp={nameRef} isError={isError} />
              <Input label="Last Name" refProp={lastNameRef} />
              <Input label="Email*" refProp={emailRef} isError={isError} />
              <Input label="Phone*" refProp={phoneRef} isError={isError} />
            </div>

            <div>
              <p className="text-[#D0A95C] font-semibold text-sm mb-1">
                Message*
              </p>

              <p className={`text-sm font-semibold ${
                formStatus === "success"
                  ? "text-green-600"
                  : formStatus === "error"
                  ? "text-red-500"
                  : "hidden"
              }`}>
                {formStatus === "success"
                  ? "Request sent successfully"
                  : "Error sending request"}
              </p>

              <input
                ref={message}
                placeholder="Write your message"
                className={`w-full mt-2 border-b bg-transparent outline-none py-2 text-sm
                ${isError ? "border-red-500 text-red-500" : "border-black text-black placeholder-gray-500"}`}
              />
            </div>

            <button
              onClick={handleSubmit}
              disabled={isLoading}
              className="w-full py-3 rounded-xl font-semibold text-white
              bg-gradient-to-r from-[#D0A95C] to-[#bfa06a]
              shadow-[0_15px_40px_rgba(208,169,92,0.4)]
              hover:scale-[1.03] transition-all disabled:opacity-60"
            >
              {isLoading ? "Sending..." : "Book Demo"}
            </button>

          </div>
        </div>
      </div>
    </section>
  );
};

const Input = ({ label, refProp, isError }) => (
  <div>
    <p className="text-[#D0A95C] font-semibold text-sm mb-1">{label}</p>
    <input
      ref={refProp}
      className={`w-full border-b bg-transparent outline-none py-2 text-sm
      ${isError ? "border-red-500 text-red-500" : "border-black text-black placeholder-gray-500"}`}
    />
  </div>
);

export default BookADemo;